/**
 * Clamps a number.
 * @param value value to clamp
 * @param min minimum value
 * @param max maximum value
 */
export function clamp(value: number, min: number, max: number) {
  return Math.max(min, Math.min(max, value));
}



// WEBPACK FOOTER //
// ./app/javascript/utils/math.ts